/// <reference types="vite/client" />
/*
 * Consumer-auth seam. my.trumin uses its OWN participant Cognito pool,
 * DISTINCT from the manage/admin pool (kickoff architecture guardrail).
 *
 * Config comes exclusively from environment at build time — no values are
 * invented here (PROCESS-3 / PROGRAMME-AD-NO-FABRICATED-DATA-IN-BUILDS-V1).
 * Until the pool is provisioned and these env vars are set by the legitimate
 * owner, auth reports 'not-configured' and the UI says so honestly.
 */

export type AuthStatus = 'not-configured' | 'configured'

export interface ConsumerAuthConfig {
  region: string
  userPoolId: string
  userPoolClientId: string
  /** Hosted-UI domain + PKCE callback — present once stage hosting exists. */
  hostedUiDomain?: string
  callbackUrl?: string
}

export function readAuthConfig(
  env: Record<string, string | undefined> = import.meta.env,
): ConsumerAuthConfig | null {
  const region = env.VITE_CONSUMER_COGNITO_REGION
  const userPoolId = env.VITE_CONSUMER_COGNITO_USER_POOL_ID
  const userPoolClientId = env.VITE_CONSUMER_COGNITO_CLIENT_ID
  if (!region || !userPoolId || !userPoolClientId) return null
  return {
    region,
    userPoolId,
    userPoolClientId,
    hostedUiDomain: env.VITE_CONSUMER_COGNITO_HOSTED_UI_DOMAIN || undefined,
    callbackUrl: env.VITE_CONSUMER_COGNITO_CALLBACK || undefined,
  }
}

export function authStatus(config: ConsumerAuthConfig | null): AuthStatus {
  return config ? 'configured' : 'not-configured'
}
